import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-000b2a98")
const _hoisted_1 = { class: "progress-wrapper" }
const _hoisted_2 = { class: "progress" }
const _hoisted_3 = {
  key: 0,
  class: "percentage-num"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "unit" }, "%", -1)
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", {
        class: "complete-val",
        style: _normalizeStyle(`width: ${_ctx.completeVal}%`)
      }, null, 4)
    ]),
    (_ctx.showPercentage)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
          _createTextVNode(_toDisplayString(_ctx.completeVal), 1),
          _hoisted_4
        ]))
      : _createCommentVNode("", true)
  ]))
}